import styled from 'styled-components';
import colors from '../../../helpers/colors';

export const Divider = styled.hr`
  background-color: ${colors.neutral04};
  border: none;
  height: 1px;
  margin: 0;
`;
